export const ListQueryKey = 'productCates';
export const DetailQueryKey = 'productCate';
export const Urls = {
  selectUrl: '/commodity/cate/list',
  updateUrl: '/commodity/cate/update',
  deleteUrl: '/commodity/cate/delete',
  createUrl: '/commodity/cate/create',
  detailUrl: '/commodity/cate/detail'
};